import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-historico-paciente`

    return {
        list(queryParms = {}) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        loadFields(queryParms = {}) {

            return repository.get(`${baseUrl}/load-field?${urlUtil.serialize(queryParms)}`)
        },
    }
}
